<div class="avatar-upload-current">
    <img class="avatar-upload-user-avatar img-circle"  src="{{defaultAvatarImageUrl }}">        
    <span>{{avatarCaption}}</span> 
</div>